import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { FullNetworkContent } from './redux/networkcontent.selectors';
import { getNetworkContent, getNetworkContentRevision } from './redux/networkcontent.actions';
import { App } from '../../App';
import { SmartContainer, Surface } from '../../styles/Containers';
import { FullScreenLoader } from '../../components/Loaders/FullScreenLoader';
import { NetworkContentForm } from './NetworkContentForm';
import { RevisionSelector } from '../../components/Publishing/RevisionSelector';
import { StyledH1, StyledP } from '../../styles/StyledHTML';
import { NetworkProductSelector } from '../NetworkProducts/NetworkProductSelector';
import { hasPurchasedProduct, useNetworkProductPurchased } from '../NetworkOrders/NetworkOrdersService';
import { FullNetworkOrders } from '../NetworkOrders/redux/networkorder.selectors';
import { searchNetworkOrdersAccountLevel } from '../NetworkOrders/redux/networkorder.actions';

export const ViewNetworkContent = () => {

    // New Modal
    const dispatch = useDispatch();
    const store = FullNetworkContent();
    const storeOrders = FullNetworkOrders();

    const { id } = useParams();
    const thisId = parseInt(id)
    const [activeItem, setActiveItem] = useState(null);


    const { hasAccess, setProducts, products } = useNetworkProductPurchased(products)


    // --------------------------
    // Effects
    // --------------------------

    // Get This Item
    useEffect(() => { dispatch(getNetworkContent(thisId)) }, [dispatch, thisId]);

    // Get Network Orders
    useEffect(() => { dispatch(searchNetworkOrdersAccountLevel(1, 9999, null)) }, [])

    // Set Active Item
    useEffect(() => {
        if (store?.activeItem) setActiveItem(store.activeItem);
    }, [store?.activeItem])

    useEffect(() => {
        // We Need Both to Make an decision
        if (!activeItem) return;
        setProducts(activeItem?.meta?.products);
    }, [activeItem])


    // --------------------------
    // Renders
    // --------------------------



    // Render Page

    return (
        <App title="Network Content">

            {store?.activeItemLoading && (<FullScreenLoader />)}
            {!store?.activeItemLoading && (
                <SmartContainer thinking={store?.deleteLoading}>
                    <StyledH1>{activeItem?.name}</StyledH1>
                    {hasAccess && (<StyledP>YOU HAVE ACCESS</StyledP>)}
                    {!hasAccess && (<StyledP>YOU DO NOT HAVE ACCESS</StyledP>)}
                </SmartContainer>
            )}
        </App>
    )
}